require('z-shop-js-env');
require('z-shop-css-env/style.css');
require('z-shop-ui/dist/z-shop-ui.css');

var wrapper = document.createElement('div');
wrapper.innerHTML = require('z-shop-ui/dist/icons.svg');
// Icons shouldn't have gradients, they may not render them because of hidden div
wrapper.style.display = 'none';
// Insert on top of everything in the body to not break the fragment identification
// Polling is needed since document.body is null for hidden tabs in Firefox
(function pollForBody() {
    if (document.body) {
        document.body.insertBefore(wrapper, document.body.firstChild);
    } else {
        setTimeout(pollForBody, 30);
    }
})();
// Add a class name to body to allow people support multiple version at once
var parts = RELEASE_VERSION.split('.');
document.documentElement.className += ' z-base-assets-major-' + parts[0]
                                    + ' z-base-assets-minor-' + parts[1]
                                    + ' z-base-assets-patch-' + parts[2];

exports.classnames = require('classnames');
exports['z-shop-ui'] = require('z-shop-ui');
exports.react = require('react');
exports['react-dom'] = require('react-dom');
exports['react-addons-css-transition-group'] = require('react-addons-css-transition-group');
exports['z-shop-event-bus'] = require('z-shop-event-bus');
exports.tranzlate = require('tranzlate');

if (window.location.search.indexOf('translationDebuggingMode=1') >= 0) {
    exports.tranzlate.passThrough = true;
}

exports['safe-fetch'] = require('./fetch-extension');



//////////////////
// WEBPACK FOOTER
// ./src/bundle.js
// module id = 213
// module chunks = 0